export default __webpack_public_path__ + "static/media/Xetra_2020_logo.8fc0a5e4.svg";